import { profile } from "@/data/portfolio";

const Footer = () => (
    <footer data-testid="footer" className="relative border-t border-white/5 py-14">
        <div className="mx-auto flex max-w-7xl flex-col items-center gap-4 px-4 text-center sm:px-6 lg:px-8">
            <div>
                <p className="font-display text-lg font-semibold tracking-tight text-slate-50">
                    {profile.name}
                </p>
                <p className="mt-1 font-mono text-[10px] uppercase tracking-[0.3em] text-slate-500">
                    {profile.role}
                </p>
            </div>

            <p className="text-xs text-slate-600">
                © {new Date().getFullYear()} {profile.name}. All rights reserved.
            </p>
        </div>
    </footer>
);

export default Footer;
